/**************************************************
 * Nombre:       Seccion_Pedidos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {LocalShipping, ManageSearch, PointOfSale} from '@mui/icons-material'
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_TEXTO,
    CASILLA_TITULO_DATO,
    CASILLA_TITULO_MONEDA
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useContext} from "react";
import {usuarioContext} from "../../App";
import {ESTADOPEDIDO} from "../../Constantes";
import Dialogo_Pedido_Datos from "../Dialogos/Dialogo_Pedido_Datos";
import Dialogo_Pedido_Envio from "../Dialogos/Dialogo_Pedido_Envio";
import Dialogo_Pedido_Pago from "../Dialogos/Dialogo_Pedido_Pago";


const Seccion_Pedidos = () => {
    const usuario = useContext(usuarioContext).usuario
    const {
        props,
        cargarNuevamente,
        numeroFilas
    } = useObtenerColleccionTabla2025({coleccion: 'pedidos'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Pedido_Datos,
        titulo: 'Detalles del cliente',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoPago, abrir: abrirPago} = useDialogo({
        Componente: Dialogo_Pedido_Pago,
        titulo: 'Detalles del pago',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoEnvio, abrir: abrirenvio} = useDialogo({
        Componente: Dialogo_Pedido_Envio,
        titulo: 'Detalles del envio',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'pago':
                abrirPago(data)
                break
            case 'envio':
                abrirenvio(data)
                break
        }
    }


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1400px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoPago/>

                <DialogoEnvio/>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Pedidos'}
                        descripcion={`${numeroFilas} pedidos en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        // clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //ComponenteInferior={ExportadorDatos}

                    />
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Seccion_Pedidos

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombres'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    }
]


const datosCabecera = [

    {
        nombre: 'Numero',
        direccion: 'left',
        propiedades: ['consecutivo', 'nombres', 'apellidos'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },

    {
        nombre: 'Ciudad',
        direccion: 'left',
        propiedad: 'ciudad',
        titulo: 'departamento',
        tipo: CASILLA_TITULO_DATO
    },

    {
        nombre: 'Pago',
        direccion: 'left',
        propiedad: 'valorPagado',
        titulo: 'estadoPago',
        tipo: CASILLA_TITULO_MONEDA
    },


    {
        nombre: 'Estado',
        direccion: 'left',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOPEDIDO
    },


]


const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Pago',
        id: 'pago',
        icono: PointOfSale
    },
    {
        nombre: 'Envio',
        id: 'envio',
        icono: LocalShipping
    }
]


